<app-basic-user-picker>
  <app-workspace-user-picker-content
    left-content
  ></app-workspace-user-picker-content>
</app-basic-user-picker>
